import { createAction } from "@reduxjs/toolkit";
import type { ProviderStudioListItem } from "@shared-kernel/application/ports/provider/provider-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const retrieveProviderStudio = createApiThunk<ProviderStudioListItem, string>(
  "provider/studio/retrieve",
  async (id, { extra: { providerRepository } }) => {
    return providerRepository!.getStudioById(id);
  },
);

export const resetRetrieveProviderStudio = createAction("provider/studio/resetRetrieve");
